import * as loadingActions from '../../Loading/loadingActions';
import * as types from './dashboardTypes';

export function setDashboardIsLoading()
{
    return function(dispatch) {
        dispatch(loadingActions.setLoading(types.DASHBOARD_LOADING));
    };
}